import { Typography } from '@mui/material'

import { ModalWrapProps } from 'common/interfaces'
import { deleteBtnStyle } from 'common/styles'
import ModalActionCancelButtons from 'components/Modals/components/ModalActionCancelButtons'
import ModalWrap from 'components/ModalWrap'
import { useSessionState } from 'context/Session'
import { useStartOver } from 'utils/flow'

type RestartFlowModalProps = Pick<ModalWrapProps, 'open' | 'onClose'>

export default function RestartFlowModal({ open, onClose }: RestartFlowModalProps): JSX.Element {
  const startOver = useStartOver(true)

  const { isSubmitted } = useSessionState()

  const restartFlowHandler = (): void => {
    startOver()
    onClose()
  }

  return (
    <ModalWrap
      title="Restart this flow?"
      open={open}
      onClose={onClose}
      actions={
        <ModalActionCancelButtons
          actionHandler={restartFlowHandler}
          onClose={onClose}
          textAction="Restart flow"
          textCancel="Cancel"
          actionStyle={deleteBtnStyle}
        />
      }
    >
      {!isSubmitted && (
        <Typography>
          This will delete all of your entered data. This action cannot be undone.
        </Typography>
      )}
    </ModalWrap>
  )
}
